import { render, staticRenderFns } from "./AuditLogViewer.vue?vue&type=template&id=d567d96c&"
import script from "./AuditLogViewer.vue?vue&type=script&lang=js&"
export * from "./AuditLogViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports